import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SedsModalModule, SedsBasicButtonModule, SedsModalAbstractComponent, SedsFlatButtonModule } from "@serasa/shared/seds";

@Component({
    selector: 'pl-user-profile-change-confirmation',
    templateUrl: './user-profile-change-confirmation.component.html',
    styleUrls: ['./user-profile-change-confirmation.component.scss'],
    imports: [CommonModule, SedsModalModule, SedsBasicButtonModule, SedsFlatButtonModule]
})
export class UserProfileChangeConfirmationComponent extends SedsModalAbstractComponent implements OnInit {
    public title: string = '';
    public content: string = '';

    constructor() {
        super();
    }

    override ngOnInit() {
        super.ngOnInit();
        this.title = this.data?.title;
        this.content = this.data?.content;
    }

    public closeModal(): void {
        this.close('cancelled');
    }

    public alterarPerfil(): void {
        this.close('confirmed');
    }
}
